(function () {
  'use strict';
  const $popups = $('.custom-popup');
  if (!previewMode) {
    $popups.each(function () {
      // Variáveis
      const $popup = $(this);
      const popupId = $popup.attr('id');
      const popupIdN = somenteNumeros(popupId);
      const popupSettings = $popup.data('settings');
      // Exibe imediatamente
      if (popupSettings['open-rule'] === 'instantly') {
        openPopup(popupId, popupSettings);
      }
      // Exibe na intenção de saída
      else if (popupSettings['open-rule'] === 'exit_attempt') {
        if (isMedia('xl') || isMedia('lg')) {
          setTimeout(() => {
            document.addEventListener('mouseout', function (evt) {
              const shouldShowExitIntent = !evt.toElement && !evt.relatedTarget && evt.clientY < 10;
              if (shouldShowExitIntent) {
                openPopup(popupId, popupSettings);
              }
            });
          }, 5000);
        } else {
          $(document).on('scroll', () => {
            myScrollSpeed(() => {
              openPopup(popupId, popupSettings);
            });
          });
        }
      }
      // Exibe após determinado tempo (segundos) / Neste caso, não pode haver produtos no carrinho
      else if (getNumCartItems() === 0) {
        let popupDelay = somenteNumeros(popupSettings['open-rule']) || 1;
        popupDelay = popupDelay * 1000;
        setTimeout(() => {
          openPopup(popupId, popupSettings);
        }, popupDelay);
      }
    });
  }

  // Ao clicar no botão de consentimento (Grava e fecha modal)
  $('[data-popup-agreement]').on('click', function (ev) {
    ev.preventDefault();
    const popupId = $(this).data('popup-agreement');
    setCookie('ppup-' + popupId, 1, 30);
    modalClose('popup-' + popupId);
  });

  // Exibe um popup
  function openPopup(popupId, popupSettings) {
    if (!popupOpened(somenteNumeros(popupId)) && showPopupResolution(popupSettings) && !hasPopupOpen()) {
      popupSetOpen(somenteNumeros(popupId), popupSettings['cookie-validity']);
      modalOpen(popupId);
      setTimeout(() => {
        initInputsMask();
        initFormValidation();
      }, 100);
    }
  }

  // Armazena a abertua do popup
  function popupSetOpen(popupId, expDays) {
    // Grava na sessão
    if (expDays === 'session') {
      sessionStorage.setItem('ppup-' + popupId, 1);
    }
    // Grava nos cookies
    else if (expDays !== 'agreement') {
      setCookie('ppup-' + popupId, 1, expDays);
    }
  }

  // Verifica se um popup já foi aberto
  function popupOpened(popupId) {
    return getCookie('ppup-' + popupId) || sessionStorage.getItem('ppup-' + popupId);
  }

  // Retorna a quantidade de items no carrinho
  function getNumCartItems() {
    return $('.v-cart-count').text() ? Number(somenteNumeros($('.v-cart-count').text())) : 0;
  }

  // Verifica a exibiçao por resolução
  function showPopupResolution(popupSettings) {
    const showDesktop = popupSettings['show-desktop'] == 1;
    const showMobile = popupSettings['show-mobile'] == 1;
    if (showDesktop && (isMedia('xl') || isMedia('lg'))) {
      return true;
    } else if (showMobile && (isMedia('md') || isMedia('sm') || isMedia('xs'))) {
      return true;
    }
    return false;
  }

  // Verifica se já existe um popup aberto
  function hasPopupOpen() {
    return $('.custom-popup.open').length > 0;
  }

  // Intenção de saída para celular
  function myScrollSpeed(cb) {
    const delta = myScroll();
    if (delta < -80 && typeof cb === 'function') {
      cb();
    }
  }
  var myScroll = (() => {
    let last_position,
      new_position,
      timer,
      delta,
      delay = 50;
    function clear() {
      last_position = null;
      delta = 0;
    }
    clear();
    return () => {
      new_position = window.scrollY;
      if (last_position != null) {
        delta = new_position - last_position;
      }
      last_position = new_position;
      clearTimeout(timer);
      timer = setTimeout(clear, delay);
      return delta;
    };
  })();
})();
